export default __webpack_public_path__ + "static/media/playlistDo.8e729817.svg";